import { getFocusableElements } from '../../shared/focus';
import {
  isActivationKey,
  isEscapeKey,
  isNextVerticalKey,
  isPrevVerticalKey,
  isTabKey,
  resolveNextIndexWithoutLoop
} from '../../shared/keyboard';

const MENU_LINK_SELECTOR = 'a[href]';

export class DropdownKeyboard {
  constructor(ui, visibility) {
    this.ui = ui;
    this.visibility = visibility;
  }

  getMenuLinks = () => getFocusableElements(this.ui.section, MENU_LINK_SELECTOR);

  openAndFocusFirstLink = () => {
    this.visibility.show();
    this.getMenuLinks()[0]?.focus();
  };

  focusLink = (event) => {
    const links = this.getMenuLinks();
    const index = links.indexOf(document.activeElement);

    if (isPrevVerticalKey(event) && index === 0) {
      this.ui.focusOption();

      return;
    }

    links[resolveNextIndexWithoutLoop(event, index, links.length - 1)]?.focus();
  };

  handleTriggerKeydown = (event) => {
    if (isEscapeKey(event)) {
      this.visibility.closeAndReturnFocus();
    } else if (isActivationKey(event) || isNextVerticalKey(event)) {
      event.preventDefault();
      this.openAndFocusFirstLink();
    }
  };

  handleLinkKeydown = (event) => {
    if (isEscapeKey(event)) {
      this.visibility.closeAndReturnFocus();
    } else if (isNextVerticalKey(event) || isPrevVerticalKey(event)) {
      event.preventDefault();
      this.focusLink(event);
    } else if (isTabKey(event)) {
      this.handleLinkTab(event);
    }
  };

  handleLinkTab = (event) => {
    const links = this.getMenuLinks();
    const index = links.indexOf(document.activeElement);

    if (event.shiftKey && index === 0) {
      event.preventDefault();
      this.visibility.closeAndReturnFocus();
    } else if (!event.shiftKey && index === links.length - 1) {
      event.preventDefault();
      this.visibility.closeAndFocusNextOption();
    }
  };
}
